var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    wrapperMargin: spacing.medium,
    heroFontSize: '20rem',
    heroColor: colors.contrasts.grey1111,
    textWrapperMargin: spacing.small,
    textWrapperColor: colors.contrasts.grey100100,
    titleFontSize: typography.fontSizeXLarge,
    titleMargin: spacing.xxSmall,
    subtitleFontSize: typography.fontSizeSmall,
    buttonWrapperMargin: spacing.small
  };
};
export default generateComponentTheme;